<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>机构管理</el-breadcrumb-item>
        <el-breadcrumb-item>机构分类</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form
        :model="listParams"
        label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="分类名称：">
              <el-input
                size="small"
                v-model="listParams.classifyName"
                placeholder="请输入分类名称">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button
                size="small"
                type="primary"
                @click="loadTableData">
                查询
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange">

      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button
            class="align-left"
            type="primary"
            size="small"
            @click="toCreate">
            新增
          </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table
        slot="content"
        :data="tableData"
        max-height="800"
        border>

        <el-table-column
          align="center"
          type="selection"
          width="55">
        </el-table-column>

        <el-table-column
          prop="id"
          align="center"
          label="id">
        </el-table-column>

        <el-table-column
          prop="classifyName"
          align="center"
          label="分类名称">
        </el-table-column>

        <el-table-column
          prop="sort"
          align="center"
          label="排序">
        </el-table-column>

        <el-table-column
          prop="subdivision"
          align="center"
          label="下属机构">
        </el-table-column>

        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <confirm-button
              type="text"
              style="margin: 0 10px;"
              title="确认要停用该条数据？"
              @confirmed="forbidItem(scope.row.id)">
              <span>停用</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <el-dialog
      class="hx-to-create-template"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      @close="resetDialogForm"
      :close-on-click-modal="false">
      <div>
        <el-form
          ref="dialogForm"
          :model="itemParams"
          :rules="checkItemParams"
          label-width="120px">
          <el-form-item label="分类名称 ：" prop="classifyName">
            <el-input
              v-model="itemParams.classifyName"
              size="small"
              placeholder="请输入分类名称">
            </el-input>
          </el-form-item>

          <el-form-item label="序号：" prop="sort">
            <el-input-number size="small" v-model="itemParams.sort" :min="1" label="描述文字"></el-input-number>
          </el-form-item>

          <el-form-item label="是否启用：" prop="isStartUsing">
            <el-switch
              v-model="itemParams.isStartUsing"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>

          <el-form-item>
            <el-button
              :disabled="isDisabled"
              size="small"
              type="primary"
              @click="saveItem('dialogForm')">
              保 存
            </el-button>

            <el-button
              size="small"
              @click="dialogVisible = false">
              取 消
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      listParams: {
        classifyName: ''
      },
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      dialogTitle: '',
      dialogVisible: false,
      isDisabled: false,
      itemParams: {
        classifyName: '',
        sort: 1,
        isStartUsing: false
      },
      checkItemParams: {
        classifyName: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入序号', trigger: 'change' }
        ],
        isStartUsing: [
          { required: true, message: '请选择是否启用', trigger: 'change' }
        ]
      }
    };
  },
  mounted () {
    this.loadTableData();
  },
  methods: {
    loadTableData () {

    },
    /**
       * 新增数据
       */
    toCreate () {
      this.dialogVisible = true;
    },
    /**
       * 关闭对话框时重置表单
       */
    resetDialogForm () {
      this.$refs.dialogForm.resetFields();
    },
    /**
       * pageIndex的change事件
       * @param val
       */
    handleCurrentChange (val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
       * pageSize的change事件
       * @param val
       */
    handleSizeChange (val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
       * 停用条目数据
       * @param id
       */
    forbidItem (id) {

    },
    /**
       * 保存新增或修改
       * @param name
       */
    saveItem (name) {
      this.isDisabled = true;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.isDisabled = false;
        } else {
          this.isDisabled = false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
  .home-container{
    .alert-text{
      color: #E9A021;
      cursor: default;
    }
  }
</style>
